import { withStyles } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { getRADeathClaim } from '../../../../../claim/reducers/claim-reducers/ra-death-claim-reducer';
import { RaDeathWrapper } from '../../../../../forms';
import { ExpansionPanel } from '../../../../../forms/form-components/expansion-panel/expansion-panel';
import { State } from '../../../../../redux/root-reducer';
import { getObjectWarning } from '../../../../../shared-functions';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { AddressDetailsView } from './address-details/address-details';
import { BankingDetailsView } from './banking-details/banking-details';
import { ContactDetailsView } from './contact-details/contact-details';
import { ExternalPoliciesView } from './external-policy/external-policies';
import { PersonalDetailsView } from './personal-details/personal-details-view';

type Props = StyledComponent & {
    validationErrors: string;
};
const lifeAssuredDetailsView: React.FunctionComponent<Props> = ({ validationErrors }: Props) => {
    let notifier;
    if (validationErrors && validationErrors.includes('LifeAssuredDetails')) {
        notifier = getObjectWarning(validationErrors, validationErrors);
    }
    return (
        <ExpansionPanel name="Life Assured Details" notifier={notifier}>
            <PersonalDetailsView />
            <ContactDetailsView />
            <AddressDetailsView />
            <RaDeathWrapper>
                <BankingDetailsView />
            </RaDeathWrapper>
            <ExternalPoliciesView />
        </ExpansionPanel>
    );
};

const mapStateToProps = (state: State) => ({
    validationErrors: getRADeathClaim(state).validationErrors,
});

export const LifeAssuredDetailsView = connect(
    mapStateToProps,
    {}
)(withStyles(styles)(lifeAssuredDetailsView));
